import styled from 'styled-components'
import media from 'styles/media'
import Colors from 'styles/Colors'
import { Body, HeadlineM, Overline, Subtitle, Subtitle2 } from 'components/Text'
import { Link as GatsbyLink } from 'gatsby'

export const Wrapper = styled.section`
  padding-top: 192px;
  position: relative;
  ${media.tablet} {
    padding-top: 0;
  }
`
export const Article = styled.article`
  width: 984px;
  margin: 0 auto;
  @media screen and (max-width: 1395px) {
    width: 732px;
    margin: 0 auto;
  }
  ${media.tablet} {
    width: 100%;
  }
`
export const Image = styled.img`
  width: 100%;
  height: 458px;
  object-fit: cover;
  ${media.mobile} {
    height: 193px;
  }
`

export const AuthorImage = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 12px;
  border-radius: 100%;
  ${media.mobile} {
  }
`

export const ArticleContent = styled.div`
  width: 732px;
  margin: 0 auto;
  @media screen and (max-width: 830px) {
    width: calc(100% - 96px);
  }
  ${media.mobile} {
    width: calc(100% - 24px);
  }
`
export const Label = styled(Overline)`
  margin-top: 120px;
  ${media.mobile} {
    margin-top: 48px;
  }
`
export const Title = styled(HeadlineM)`
  margin-top: 15px;
  padding-bottom: 50px;
  ${media.tablet} {
    font-size: 36px;
    line-height: 36px;
  }
`
export const Date = styled(Body)`
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  span {
    margin-right: 12px;
  }
  ${media.tablet} {
    font-size: 16px;
    line-height: 24px;
  }
`
export const Paragraph = styled(Body)`
  margin-bottom: 16px;
  color: ${Colors.softBlack};
  white-space: pre-line;
`
export const Unordered = styled.ul`
  list-style-type: none;
  padding: 48px 0 48px 48px;
  margin: 0;
  position: relative;
  li {
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    color: ${Colors.softBlack};
    position: relative;
    ::before {
      content: '//';
      width: 14px;
      left: -22px;
      color: ${Colors.rossoCorsa};
      line-height: 150%;
      position: absolute;
    }
    ul {
      padding: 48px 0 0 48px;
      margin-left: 24px;
      li {
        ::before {
          content: '-';
          font-size: 36px;
          width: 12px;
          line-height: 60%;
          color: ${Colors.rossoCorsa};
        }
      }
    }
  }
  ${media.fullWidth} {
    li {
      position: relative;
      flex-direction: column;
      width: calc(100% - 16px);
      margin-left: 16px;
      ::before {
        content: '//';
        width: 0.8vw;
        line-height: 1.4vw;
        top: auto;
        margin-right: 0;
        color: ${Colors.rossoCorsa};
        position: absolute;
        left: -1.2vw;
        display: flex;
        align-self: center;
      }
      ul {
        padding: 48px 0 0 14px;

        li {
          ::before {
            content: '-';
            font-size: 2.1vw;
            width: 0.7vw;
            line-height: 60%;
            color: ${Colors.rossoCorsa};
          }
        }
      }
    }
  }
  ${media.mobile} {
    padding: 48px 0 0 14px;

    li {
      position: relative;
      flex-direction: column;
      width: calc(100% - 16px);
      margin-left: 12px;
      ::before {
        content: '//';
        width: 14px;
        margin-right: 0;
        color: ${Colors.rossoCorsa};
        position: absolute;
        left: -20px;
      }
      ul {
        padding: 48px 0 0 14px;
      }
    }
  }
`

export const Ordered = styled.ol`
  padding: 48px 0 48px 72px;
  margin: 0;
  li {
    padding-left: 13px;
    margin-bottom: 24px;
  }
  ${media.mobile} {
    padding: 48px 0 0 14px;
  }
`
export const Link = styled.a`
  text-decoration: underline;
  color: ${Colors.softBlack};
  font-family: 'Maison Neue Mono';
  font-weight: 700;
  cursor: pointer;
  font-size: 16px;
`
export const ArticleSubTitle = styled(Subtitle)`
  margin-bottom: 12px;
  margin-top: 48px;
`
export const ArticleSubTitle2 = styled(Subtitle2)`
  margin-bottom: 12px;
  margin-top: 48px;
`

export const Video = styled.iframe`
  padding: 48px 0 48px;
  height: 390px;
  width: 732px;
  box-sizing: content-box;
  ${media.mobile} {
    width: 100%;
    height: 54vw;
    padding: 0;
    margin: 48px 0;
  }
`
export const Back = styled(GatsbyLink)`
  position: absolute;
  left: 96px;
  top: 192px;
  button {
    padding: 0;
    font-weight: 500;
    transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
    transition: 0.4s;
    ::after {
      transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
      transition: 0.4s;
    }
    :hover {
      margin-left: -4px;
      ::after {
        transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
      }
    }
  }
  ${media.tabletLandscape} {
    display: none;
  }
`
export const Quote = styled.div`
  border-left: solid 2px ${Colors.earthYellow};
  padding-left: 72px;
  margin: 48px 0;
  ${media.mobile} {
    padding-left: 36px;
  }
`
export const Next = styled(GatsbyLink)`
  padding-right: 173px;
  margin-top: 112px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  button {
    padding: 0;
    transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
    transition: 0.4s;
    ::after {
      transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
      transition: 0.4s;
    }
    :hover {
      margin-right: -4px;
      ::after {
        transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
      }
    }
  }
  ${media.mobile} {
    padding-right: 12px;
  }
`
export const ArticleImage = styled.img`
  width: 100%;
  margin: 12px auto;
`
